import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import {
    FR_EVENT_DETAILS_SUB_PATH,
    FR_EVENT_ROOT_PATH,
    FR_EVENTS_LIST_PATH,
    ROOT_PATH,
} from '../../router/constants';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useAutoNavigateToEvent() {
    const unitAssignment = useUnitAssignment();
    const navigate = useNavigate();
    const eventId = unitAssignment?.assignedEvent?.eventId;
    const location = useLocation();
    const { rollOutFrFooterAndTabRedesignEnabled } = useEnabledFeatures();

    useEffect(
        function autoNavigateToEvent() {
            if (eventId) {
                const targetPath = rollOutFrFooterAndTabRedesignEnabled
                    ? `${FR_EVENT_ROOT_PATH}/${eventId}/${FR_EVENT_DETAILS_SUB_PATH}`
                    : `${FR_EVENT_ROOT_PATH}/${eventId}`;

                // Don't auto-navigate if the user is intentionally viewing a different event
                // (e.g., viewing/editing a cleared event). Only auto-navigate from non-event
                // pages like homepage or events list.
                const isOnDifferentEvent =
                    location.pathname.startsWith(`${FR_EVENT_ROOT_PATH}/`) &&
                    !location.pathname.startsWith(`${FR_EVENT_ROOT_PATH}/${eventId}`);

                if (!isOnDifferentEvent && location.pathname !== targetPath) {
                    const isFromHomepage = location.pathname === ROOT_PATH;
                    navigate(targetPath, {
                        state: {
                            ...location.state,
                            // When auto-navigating from the homepage, set a sensible back destination
                            // since the homepage would just redirect back (loop)
                            ...(isFromHomepage
                                ? { previousLocationPathname: FR_EVENTS_LIST_PATH }
                                : {}),
                        },
                        // Replace the intermediate route entry so the browser back button
                        // returns to the page the user was on before (e.g. Map, Events List)
                        replace: true,
                    });
                }
            }
        },
        [rollOutFrFooterAndTabRedesignEnabled, eventId, navigate, location]
    );
}
